export default {
  women: {
    en: 'Women',
  },
  men: {
    en: 'Men',
  },
  seeAll: {
    en: 'See all',
  },
  collections: {
    en: 'Collections',
  },
}
